module.exports = __webpack_public_path__ + "img/roundBookmarked.fcda3458.svg";